import React, { useState } from 'react';
import NumericInput from 'react-numeric-input';
import { withTranslation } from 'react-i18next';
import Habitacion from './habitacion';
import './dropdownDistribucionHabitaciones.css';

const DistribucionHabitaciones = ({
  listaHabitaciones,
  actualizarAdultos,
  actualizarMenores,
  actualizarEdadesMenores,
  habitaciones,
  cant_huespedes,
  cantidadHabitaciones,
  isInList,
  t,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleClickButton = (e) => {
    e.preventDefault();
    setShowModal(!showModal);
  };

  if (typeof window === 'undefined') return null; // postpone render until browser

  const rooms = [];
  for (let i = 0; i < habitaciones; i++) {
    rooms.push(
      <div key={i}>
        <hr className='divider' />
        <Habitacion
          listaHabitaciones={listaHabitaciones}
          actualizarAdultos={actualizarAdultos}
          actualizarMenores={actualizarMenores}
          actualizarEdadesMenores={actualizarEdadesMenores}
          habitacion={i}
        />
      </div>
    );
  }

  return (
    <div
      className={`distribucion mx-2 search_main_distribucion border-b w-full border-solid${
        isInList ? ' dropdown-input-inList' : ''
      }`}
    >
      <button
        onClick={handleClickButton}
        className='flex justify-evenly gap-3 items-center text-gray-400'
      >
        <div className='flex'>
          <i className='fa fa-user mr-2' />
          <span>{cant_huespedes}</span>
        </div>
        <div className='flex'>
          <i className='fa fa-bed mr-2' />
          <span>{habitaciones}</span>
        </div>
      </button>
      <div
        className={`
          ${showModal ? 'block' : 'hidden'}
          ditrubution-dropdown-container h-full
        `}
      >
        <div className='flex flex-col justify-center bg-white rounded-sm p-5 md:p-3 shadow-md '>
          <div className='titulo'>{t('searcher.rooms')}</div>
          <NumericInput
            onChange={cantidadHabitaciones}
            mobile
            className='w-full'
            value={habitaciones}
            min={1}
            max={3}
          />
          {rooms}
          <div className='text-center'>
            <button
              className='btn-confirm-actions w-full text-white rounded py-2 md:py-1 px-2'
              onClick={handleClickButton}
            >
              <i className='fas fa-check' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation(['layout'])(DistribucionHabitaciones);
